var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"data-pdf-chart":"","data-pdf-chart-title":_vm.title || null,"data-pdf-chart-subtitle":_vm.subtitle || null,"data-pdf-chart-layout":_vm.layout || null}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }